var React = require('react');

function IconReturn (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.467 8.71a.47.47 0 0 1-.508-.089L.146 5.965a.465.465 0 0 1 0-.68L2.96 2.63a.469.469 0 0 1 .791.34v1.719H7.5c.346 0 .625-.28.625-.625V1.25c0-.346.28-.625.625-.625h.625c.346 0 .625.28.625.625v2.813a2.5 2.5 0 0 1-2.5 2.5H3.75V8.28a.47.47 0 0 1-.283.43"}));
}

IconReturn.defaultProps = {"viewBox":"0 0 10 10","fill":"currentColor"};

module.exports = IconReturn;

IconReturn.default = IconReturn;
